// Router basado en hash — deliberadamente el más simple posible: sin
// dependencia externa, sin rutas anidadas ni parámetros dinámicos (ninguna
// vista de esta fase los necesita — Empresas/Usuarios/Dominios/Publicaciones
// son listados de nivel único; el detalle de una empresa, si se necesita a
// futuro, se resuelve dentro de la propia vista con un modal, no con una
// ruta `/empresas/:id`). Hash (`#/ruta`) en vez de History API: estas 3 apps
// se sirven como archivos estáticos (Vite build) sin servidor con rutas de
// fallback a `index.html` garantizado desde el día uno — hash evita 404 en
// refresh sin depender de esa configuración de infraestructura.

/** @type {Map<string, (contenedor: HTMLElement) => void | Promise<void>>} */
const rutas = new Map();

let contenedorRaiz = null;
let guardaNavegacion = null;
let rutaNoEncontrada = (contenedor) => {
  contenedor.textContent = 'Página no encontrada.';
};

/**
 * @param {string} ruta ej. '/empresas'
 * @param {(contenedor: HTMLElement) => void | Promise<void>} manejador
 */
export function registrarRuta(ruta, manejador) {
  rutas.set(ruta, manejador);
}

export function tieneRuta(ruta) {
  return rutas.has(ruta);
}

/**
 * Registra una guarda central de navegación. Debe devolver `null`/`undefined`
 * para permitir la ruta, o una ruta destino para redirigir antes de montar la
 * vista solicitada.
 *
 * @param {(ruta: string) => string | null | undefined} guarda
 */
export function registrarGuardaNavegacion(guarda) {
  guardaNavegacion = guarda;
}

/**
 * @param {(contenedor: HTMLElement) => void} manejador
 */
export function registrarRutaNoEncontrada(manejador) {
  rutaNoEncontrada = manejador;
}

/** @param {string} ruta */
export function navegarA(ruta) {
  window.location.hash = `#${ruta}`;
}

function rutaActual() {
  const hash = window.location.hash.replace(/^#/, '');
  // El router resuelve la ruta solo con el path; los query params (p.ej.
  // `?producto_id=...`) se leen dentro de cada vista con leerQueryParam().
  return hash.split('?')[0] || '/';
}

async function renderizar() {
  if (!contenedorRaiz) return;
  const ruta = rutaActual();
  const redireccion = guardaNavegacion?.(ruta);

  if (redireccion && redireccion !== ruta) {
    contenedorRaiz.innerHTML = '';
    navegarA(redireccion);
    return;
  }

  const manejador = rutas.get(ruta) ?? rutaNoEncontrada;
  contenedorRaiz.innerHTML = '';
  await manejador(contenedorRaiz);
}

/**
 * @param {HTMLElement} contenedor - elemento donde se monta cada vista.
 */
export function iniciarEnrutador(contenedor) {
  contenedorRaiz = contenedor;
  window.addEventListener('hashchange', renderizar);
  renderizar();
}

/**
 * Re-renderiza la ruta actual sin cambiar el hash. Necesario cuando el
 * estado de sesión cambia (login/logout) mientras el usuario sigue en la
 * misma ruta (`/login`, por ejemplo) — `hashchange` no se dispara solo,
 * porque el hash no cambió.
 */
export function refrescarRuta() {
  renderizar();
}
